"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// components
//
const PageOptions_1 = __importDefault(require("./PageOptions"));
//
// assets
//
const trackingCopy_1 = require("../../../../../src/copy/trackingCopy");
//
// styles
//
const StyledContainer_1 = require("./StyledContainer");
const StyledInfoContainer_1 = require("./StyledInfoContainer");
const StyledTitle_1 = require("./StyledTitle");
const StyledLink_1 = require("./StyledLink");
const StyledTimestamp_1 = require("./StyledTimestamp");
const DateFormat_1 = require("../../../general/utility/DateFormat");
const TrackingPageCard = (props) => {
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, null,
        react_1.default.createElement(StyledInfoContainer_1.StyledInfoContainer, { spaced: true },
            react_1.default.createElement(StyledTitle_1.StyledTitle, { className: 'page-title' }, props.title),
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'page-url', href: `//${props.url}`, rel: 'noopener noreferrer', target: '_blank' }, props.url),
            react_1.default.createElement(StyledTimestamp_1.StyledTimestamp, { className: 'page-created' }, `${trackingCopy_1.trackingCopy.created} ${(0, DateFormat_1.twoDigitDateFormat)(props.created)}`),
            react_1.default.createElement(StyledTimestamp_1.StyledTimestamp, { className: 'page-updated' }, `${trackingCopy_1.trackingCopy.updated} ${(0, DateFormat_1.twoDigitDateFormat)(props.updated)}`)),
        react_1.default.createElement(StyledInfoContainer_1.StyledInfoContainer, null,
            react_1.default.createElement(PageOptions_1.default, { active: props.active, onArchive: props.onArchive, onDelete: props.onDelete, onEdit: props.onEdit, onRestore: props.onRestore }))));
};
TrackingPageCard.propTypes = {
    active: prop_types_1.default.bool,
    created: prop_types_1.default.string,
    onArchive: prop_types_1.default.func,
    onDelete: prop_types_1.default.func,
    onEdit: prop_types_1.default.func,
    onRestore: prop_types_1.default.func,
    title: prop_types_1.default.string,
    updated: prop_types_1.default.string,
    url: prop_types_1.default.string
};
exports.default = TrackingPageCard;
